import { inputTypes } from "data/globalData";

export const styleFabricAssociation = "styleFabric";
export const styleTrimsAssociation = "styleTrims";
export const styleValueAddAssocition = "styleValueAdd";
export const pimTrimBreakdownAssociationObj = "trimsConsumption";
export const valueAddConsumptionAssociationObj = "valueAddConsumption";
export const pimDescCatAssociationObj = "CategorySubCategories";

export const fabricTableColumns = {
	type: { name: "Fabric Component", key: "type" },
	blend: { name: "Blend", key: "blend", input_type: inputTypes.SELECT.key },
	source_category: { name: "Source Category", key: "source_category", input_type: inputTypes.SELECT.key },
	fabric_category: { name: "Fabric Category", key: "fabric_category", input_type: inputTypes.SELECT.key },
	weave: { name: "Weave", key: "weave", input_type: inputTypes.SELECT.key },
	construction: { name: "Count Construction", key: "construction", input_type: inputTypes.SELECT.key },
	width: { name: "Width", key: "width", input_type: inputTypes.SELECT.key },
	consumption: { name: "Consumption", key: "consumption", input_type: inputTypes.ENTER.key },
	consumption_unit: { name: "Consumption Unit", key: "consumption_unit", input_type: inputTypes.SELECT.key },
};
export const trimsTableColumns = {
	category: { name: "Category", key: "category", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	description: { name: "Description", key: "description", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	color_level: { name: "Color Wise", key: "color_level", type: inputTypes.ENTER.key, defaultValue: false },
	size_level: { name: "Size Wise", key: "size_level", type: inputTypes.ENTER.key, defaultValue: false },
	channel_level: { name: "Channel Wise", key: "channel_level", type: inputTypes.ENTER.key, defaultValue: false },
	consumption_unit: {
		name: "Consumption Unit",
		key: "consumption_unit",
		type: inputTypes.ENTER.key,
		sqlCol: "unit",
		defaultValue: "",
	},
	consumption: { name: "Consumption", key: "consumption", type: inputTypes.ENTER.key, defaultValue: 0 },
	per_garment_qty: { name: "Per Garment Qty", key: "per_garment_qty", type: inputTypes.ENTER.key, defaultValue: 0 },
	wastage_percent: { name: "Wastage %", key: "wastage_percent", type: inputTypes.ENTER.key, defaultValue: 0 },
	req_for: { name: "Required For", key: "req_for", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	sourcing: { name: "Sourcing", key: "sourcing", type: inputTypes.SELECT.key.select, defaultValue: inputTypes.SELECT.key },
	price: { name: "Price", key: "price", type: inputTypes.ENTER.key, defaultValue: 0 },
	price_currency: { name: "Price Currency", key: "price_currency", type: inputTypes.ENTER.key, defaultValue: 0 },
};
export const trimBreakdownTableColumns = {
	category: { name: "Category", key: "category", type: inputTypes.SELECT.key },
	description: { name: "Description", key: "description", type: inputTypes.SELECT.key },
	gar_color: { name: "Gar. Color", key: "gar_color", type: inputTypes.ENTER.key, defaultValue: "" },
	item_color: { name: "Item Color", key: "item_color", type: inputTypes.ENTER.key, defaultValue: "" },
	gar_size: { name: "Size", key: "gar_size", type: inputTypes.ENTER.key, defaultValue: "" },
	item_size: { name: "Item Size", key: "item_size", type: inputTypes.ENTER.key, defaultValue: "" },
	gar_channel: { name: "Channel", key: "gar_channel", type: inputTypes.ENTER.key, defaultValue: "" },
	item_channel: { name: "Item Channel", key: "item_channel", type: inputTypes.ENTER.key, defaultValue: "" },
	consumption_unit: { name: "Consumption Unit", key: "consumption_unit", type: inputTypes.ENTER.key },
	consumption: { name: "Consumption", key: "consumption", type: inputTypes.ENTER.key },
	per_garment_qty: { name: "Per Garment Qty", key: "per_garment_qty", type: inputTypes.ENTER.key, defaultValue: 0 },
	wastage_percent: { name: "Wastage %", key: "wastage_percent", type: inputTypes.ENTER.key },
	req_for: { name: "Required For", key: "req_for", type: inputTypes.SELECT.key, defaultValue: "" },
	sourcing: { name: "Sourcing", key: "sourcing", type: inputTypes.SELECT.key, defaultValue: "" },
	price: { name: "Price", key: "price", type: inputTypes.ENTER.key, defaultValue: 0 },
	price_currency: { name: "Price Currency", key: "price_currency", type: inputTypes.ENTER.key, defaultValue: 0 },
};

export const sendReceiveUnitOptions = [
	{
		name: "PCS-PCS",
		key: "PCS-PCS",
	},
	{
		name: "MTR-MTR",
		key: "MTR-MTR",
	},
	{
		name: "MTR-PCS",
		key: "MTR-PCS",
	},
];
export const valueAddTableColumns = {
	category: { name: "Category", key: "category", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	description: { name: "Description", key: "description", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	placement: { name: "Placement", key: "placement", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	color_level: { name: "Color Wise", key: "color_level", type: inputTypes.ENTER.key, defaultValue: false },
	size_level: { name: "Size Wise", key: "size_level", type: inputTypes.ENTER.key, defaultValue: false },
	channel_level: { name: "Channel Wise", key: "channel_level", type: inputTypes.ENTER.key, defaultValue: false },
	placement: { name: "Placement", key: "placement", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },
	send_receive_unit: {
		name: "Send-Receive Unit",
		key: "send_receive_unit",
		type: inputTypes.SELECT.key,
		defaultValue: inputTypes.SELECT.key,
	},

	consumption_unit: {
		name: "Consumption Unit",
		key: "consumption_unit",
		type: inputTypes.ENTER.key,
		sqlCol: "unit",
		defaultValue: "",
	},
	// consumption: { name: "Consumption", key: "consumption", type: inputTypes.ENTER.key, defaultValue: 0 },
	per_garment_qty: { name: "Per Garment Qty", key: "per_garment_qty", type: inputTypes.ENTER.key, defaultValue: 0 },
	// wastage_percent: { name: "Wastage %", key: "wastage_percent", type: inputTypes.ENTER.key, defaultValue: 0 },
	// req_for: { name: "Required For", key: "req_for", type: inputTypes.SELECT.key, defaultValue: "" },
	// sourcing: { name: "Sourcing", key: "sourcing", type: inputTypes.SELECT.key.select, defaultValue: inputTypes.SELECT.key },
	price: { name: "Price", key: "price", type: inputTypes.ENTER.key, defaultValue: 0 },
	price_currency: { name: "Price Currency", key: "price_currency", type: inputTypes.ENTER.key, defaultValue: 0 },
};
export const valueAddConsumptionTableColumns = {
	category: { name: "Category", key: "category", type: inputTypes.SELECT.key },
	description: { name: "Description", key: "description", type: inputTypes.SELECT.key },
	send_receive_unit: {
		name: "Send-Receive Unit",
		key: "send_receive_unit",
		type: inputTypes.SELECT.key,
		defaultValue: inputTypes.SELECT.key,
	},
	placement: { name: "Placement", key: "placement", type: inputTypes.SELECT.key, defaultValue: inputTypes.SELECT.key },

	gar_color: { name: "Gar. Color", key: "gar_color", type: inputTypes.ENTER.key, defaultValue: "" },
	item_color: { name: "Item Color", key: "item_color", type: inputTypes.ENTER.key, defaultValue: "" },
	gar_size: { name: "Size", key: "gar_size", type: inputTypes.ENTER.key, defaultValue: "" },
	item_size: { name: "Item Size", key: "item_size", type: inputTypes.ENTER.key, defaultValue: "" },
	gar_channel: { name: "Channel", key: "gar_channel", type: inputTypes.ENTER.key, defaultValue: "" },
	item_channel: { name: "Item Channel", key: "item_channel", type: inputTypes.ENTER.key, defaultValue: "" },
	consumption_unit: { name: "Consumption Unit", key: "consumption_unit", type: inputTypes.ENTER.key },
	// consumption: { name: "Consumption", key: "consumption", type: inputTypes.ENTER.key },
	per_garment_qty: { name: "Per Garment Qty", key: "per_garment_qty", type: inputTypes.ENTER.key, defaultValue: 1 },
	// wastage_percent: { name: "Wastage %", key: "wastage_percent", type: inputTypes.ENTER.key },
	// req_for: { name: "Required For", key: "req_for", type: inputTypes.SELECT.key, defaultValue: "" },
	// sourcing: { name: "Sourcing", key: "sourcing", type: inputTypes.SELECT.key, defaultValue: "" },
	price: { name: "Price", key: "price", type: inputTypes.ENTER.key, defaultValue: 0 },
	price_currency: { name: "Price Currency", key: "price_currency", type: inputTypes.ENTER.key, defaultValue: 0 },
};

export const trimsRequiredForValues = {
	SEWING: { name: "SEWING", key: "SEWING" },
	PACKING: { name: "PACKING", key: "PACKING" },
};
export const valueAddSourcingValues = {
	PURCHASE: { name: "PURCHASE", key: "PURCHASE" },
	IMPORT: { name: "IMPORT", key: "IMPORT" },
	BUYING_ORDER: { name: "BUYING ORDER", key: "BUYING_ORDER" },
};
export const valueAddRequiredForValues = {
	SEWING: { name: "SEWING", key: "SEWING" },
	PACKING: { name: "PACKING", key: "PACKING" },
};
export const trimsSourcingValues = {
	PURCHASE: { name: "PURCHASE", key: "PURCHASE" },
	IMPORT: { name: "IMPORT", key: "IMPORT" },
	BUYING_ORDER: { name: "BUYING ORDER", key: "BUYING_ORDER" },
};
export const pimConsumpGarmentOptions = {
	ALL: { name: "ALL", key: "ALL" },
	PENDING: { name: "PENDING", key: "PENDING" },
};
